import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
export function HeroSection() {
  return <section className="relative overflow-hidden bg-slate-50 pt-16 pb-24 lg:pt-32 lg:pb-40" data-id="element-20">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 -mr-20 -mt-20 w-96 h-96 bg-teal-100 rounded-full blur-3xl opacity-50" data-id="element-21" />
      <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-80 h-80 bg-orange-100 rounded-full blur-3xl opacity-50" data-id="element-22" />

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-23">
        <div className="max-w-4xl mx-auto text-center" data-id="element-24">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-25">
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-teal-50 text-teal-700 text-sm font-medium mb-8 border border-teal-100" data-id="element-26">
              <span className="relative flex h-2 w-2" data-id="element-27">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-teal-400 opacity-75" data-id="element-28"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-teal-500" data-id="element-29"></span>
              </span>
              Now available for UK Businesses
            </span>

            <h1 className="text-4xl md:text-6xl font-bold text-slate-900 tracking-tight mb-6 leading-tight" data-id="element-30">
              Your Daily Business Tools in <br className="hidden md:block" data-id="element-31" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-600 to-teal-400" data-id="element-32">
                One Secure Platform.
              </span>
            </h1>

            <p className="text-xl text-slate-600 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-33">
              HomeLinkPro helps teams schedule work, share files and collaborate
              effortlessly. No installation required.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12" data-id="element-34">
              <Link to="/contact" data-id="element-35">
                <Button size="lg" rightIcon={<ArrowRight size={18} data-id="element-37" />} data-id="element-36">
                  Contact Us
                </Button>
              </Link>
              <Link to="/services" data-id="element-38">
                <Button variant="outline" size="lg" data-id="element-39">
                  View Services
                </Button>
              </Link>
            </div>

            <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 text-sm text-slate-500" data-id="element-40">
              <div className="flex items-center gap-2" data-id="element-41">
                <CheckCircle2 className="text-teal-500 w-4 h-4" data-id="element-42" />
                <span data-id="element-43">No credit card required</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-44">
                <CheckCircle2 className="text-teal-500 w-4 h-4" data-id="element-45" />
                <span data-id="element-46">14-day free trial</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-47">
                <CheckCircle2 className="text-teal-500 w-4 h-4" data-id="element-48" />
                <span data-id="element-49">Cancel anytime</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}